import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router'
import { useAuth } from '@/lib/auth-context'
import { AppLayout } from '@/components/app-layout'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" />
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  )
}
